








import Vue from 'vue'
import SimpleLoader from '@/components/atoms/SimpleLoader.vue'
import PageTitle from '@/components/atoms/PageTitle.vue'
import NewsContent from '@/components/molecules/NewsContent.vue'

export default Vue.extend({
  name: 'NewsDetail',
  components: {
    SimpleLoader,
    PageTitle,
    NewsContent
  },
  computed: {
    isPageLoading(): boolean {
      return this.$state.notices.isNoticeLoading
    },
    notice(): object {
      return this.$state.notices.notices.filter((notice: any) => {
        if (notice.id === this.$route.params.id) {
          return notice
        }
      })[0]
    },
    hasNotices(): boolean {
      return this.$state.notices.notices.length > 0
    }
  },
  mounted() {
    if (this.$state.notices.notices.length === 0) {
      this.$store.dispatch('notices/fetchNotices', { limit: 50 })
    }
  }
})
